import { __ } from "@wordpress/i18n";
import Tab from "../common/Tab";
import { useContext } from "react";
import SaveSettingsButton from "./SaveSettingsButton";
import { SettingsContext } from "../Settings";

const SettingsTabs = () => {
  const { sbyIsPro } = useContext(SettingsContext);

  return (
    <div className="sb-tabs">
      <div className="left-buttons">
        <Tab to="/">{__("General", "feeds-for-youtube")}</Tab>
        <Tab to={"/feeds"}>{__("Feeds", "feeds-for-youtube")}</Tab>
        {sbyIsPro ? (
          <>
            {window.sby_settings.licenseTierFeatures.includes(
              "convert_videos_to_cpt"
            ) ? (
              <Tab to={"/single-videos"}>
                {__("Single Videos", "feeds-for-youtube")}
              </Tab>
            ) : (
              ""
            )}
            <Tab to={"/translation"}>
              {__("Translation", "feeds-for-youtube")}
            </Tab>
          </>
        ) : (
          ""
        )}
        <Tab to={"/advanced"}>{__("Advanced", "feeds-for-youtube")}</Tab>
      </div>
      <div className="right-buttons">
        <SaveSettingsButton />
      </div>
    </div>
  );
};

export default SettingsTabs;
